import { Component, OnInit, ViewChild } from '@angular/core';
import { GrIrService } from '../../../../service/gr-ir/gr-ir.service';
import autoTable from 'jspdf-autotable';
import * as FileSaver from 'file-saver';
import { TreeTable } from 'primeng/treetable';
import { VendorFieldsDTOForIR,IRSearchDTO } from '../../../../models/IRSearchDTO';
import * as XLSX from 'xlsx';
import { MessageService } from 'primeng/api';
import { DatePipe } from '@angular/common';
interface Column {
  field: string;
  defaultFilter: string;
}
interface ItemElement {
  item: any;
  shipments: any[];
}
interface FilterDate{
  startDate:any
  endDate:any
}

@Component({
  selector: 'app-ir',
  templateUrl: './ir.component.html',
  styleUrl: './ir.component.scss'
})
export class IrComponent implements OnInit {
  @ViewChild('tt') tt?: TreeTable;
  mappedData: any[] = [];
  irList?: any[];
  cols!: Column[];
  sidebarVisible: boolean = false

  selectedIrData: any[] = [];
  selectedPoData: any[] = [];

  irNo: string = '';
  poNo: string = '';
  IR: string  = '';
  filteredData: any[] = [];
  limit:number=10;
  currentPage:number=1;
  totalRecords:number=0
  isLoading: boolean = false;
  irSearchDTO?:IRSearchDTO
  vendorFieldsDTOForGR?:VendorFieldsDTOForIR


  isExcel: boolean = false;
  startDate: Date | null = null;
  endDate: Date | null = null;
  dateValidation: boolean = false;
  correctDate: Date = new Date();
  constructor(
    private grIrService: GrIrService,
    private messageService: MessageService,
    private datePipe: DatePipe,
  ) {
    this.irSearchDTO=new IRSearchDTO()
    this.vendorFieldsDTOForGR=new VendorFieldsDTOForIR()
  }

  ngOnInit(): void {
    this.fetchData();
    this.initializeColumns();

    const selectedNo = history.state.selectedNo;
    if (selectedNo) {
    this.IR = selectedNo;
    this.fetchData().then(() => {
      history.replaceState({ ...history.state, selectedNo: null }, '');
    });
    }
  }


  initializeColumns() {
    this.cols = [
      { field: 'vendor_code' ,defaultFilter:''},
      { field: 'payment_status' ,defaultFilter:''},
      { field: 'invoice_no' ,defaultFilter:''},
      { field: 'invoice_date' ,defaultFilter:''},
      { field: 'ir_no' ,defaultFilter:''},
      { field: 'ir_date' ,defaultFilter:''},
      { field: 'net_value' ,defaultFilter:''},
      { field: 'tax_value' ,defaultFilter:''},
      { field: 'gross_value' ,defaultFilter:''},
      { field: 'vendor_name' ,defaultFilter:''},
      { field: 'partially_amount' ,defaultFilter:''},
      { field: 'balance_amount' ,defaultFilter:''},
      // { field: '' ,defaultFilter:''},
      // { field: 'business_place' ,defaultFilter:''},
      // { field: 'total' ,defaultFilter:''},
      // { field: 'ir_quantity' ,defaultFilter:''},
    ];
  }

  onInputChange(event: any, field: string) {
    const fieldMapping: { [key: string]: string } = {
      vendor_code: 'vendor_code',
      payment_status: 'status',
      invoice_no: 'invoice_no',
      invoice_date: 'invoice_date',
      ir_no: 'ir_no',
      ir_date: 'ir_date',
      net_value: 'net_value',
      tax_value: 'tax_value',
      gross_value: 'gross_value',
      vendor_name: 'business_name',
      partially_amount: 'partially_amount',
      balance_amount: 'balance_amount'
    };

    const inputValue = (event.target as HTMLInputElement)?.value;
    const dtoField = fieldMapping[field];
    if ("status" == dtoField || "invoice_no" == dtoField ||"invoice_date" == dtoField ||"ir_no" == dtoField ||"ir_date" == dtoField ||"net_value" == dtoField ||"tax_value" == dtoField ||"gross_value" == dtoField ||"partially_amount" == dtoField ||"balance_amount" == dtoField) {
      (this.irSearchDTO as any)[dtoField] = inputValue;
    }
    else if ("business_name" == dtoField || "vendor_code" == dtoField) {
      (this.vendorFieldsDTOForGR as any)[dtoField] = inputValue;
    }
    this.currentPage=1
    this.fetchData()
    // this.tt?.filter(inputValue, field, 'contains');
  }

  onGlobalSearch(event: any) {
    if (event?.target?.value) {
      const searchText = event.target.value;
      this.tt?.filterGlobal(searchText, 'contains');
    }
  }

  formatDate(dateString: string) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0'); // Pad with leading zero if single digit
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Pad with leading zero if single digit
    const year = date.getFullYear();
    const formattedDate = `${day}.${month}.${year}`;
    return formattedDate;
}



  async fetchData() {
    try {
      let data={
        page:this.currentPage,
        limit:this.limit,
        ir_search_dto:this.irSearchDTO,
        vendor_master_search_dto:this.vendorFieldsDTOForGR
        }
        this.isLoading=true
      const res = await this.grIrService.getIRLists(data);
      this.isLoading=false
      this.irList = res?.message.ir_list;
      this.totalRecords = res.message.total_ir

      this.mappedData = this.irList?.map((ir, index) => ({
        key: `parent_${index}`,
        data: {
          ir_no: ir.ir_no,
          vendor_code: ir.vendor_code,
          vendor_name: ir.vendor_name,
          ir_date: this.formatDate( ir.ir_date),
          payment_status:ir.payment_status,
          ir_time: ir.ir_time,
          net_value: this.formatNumber(ir.net_value ?? 0),
          tax_value: this.formatNumber(ir.tax_value ?? 0),
          gross_value: this.formatNumber(ir.gross_value ?? 0),
          invoice_no: ir.invoice_no,
          invoice_date: this.formatDate(ir.invoice_date),
          business_place: this.formatNumber(ir.business_place ?? 0),
          partially_amount: this.formatNumber(ir.partially_amount ?? 0),
          balance_amount: this.formatNumber(ir.balance_amount ?? 0),
        },
        children: ir.batch_detail.sort((a: any, b: any) => this.compareItemNo(a.line_item_no, b.line_item_no))
        .map((ir: any, childIndex: any) => ({
          key: `child_${index}_${childIndex}`,
          data: {
            ir_no: ir.gr_no,
            vendor_code: ir.po_no,
            vendor_name: ir.line_item_no,
            ir_date: ir.ir_material_code,
            ir_time: ir.ir_material_description,
            net_value: ir.ir_uom,
            tax_value: this.formatNumber(ir.total ?? 0),
            gross_value: this.formatNumber(ir.ir_tax_value ?? 0),
            invoice_no: this.formatNumber(ir.ir_gross_value ?? 0),
            invoice_date: this.formatNumber(ir.ir_net_value ?? 0),
            business_place: ir.ir_batch_no,
            ir_quantity:this.formatNumber(ir.ir_new_quantity ?? 0)
          },
        })),
      })) || [];

      if (this.IR) {
        this.mappedData = this.mappedData.filter(data => data.data.ir_no === this.IR);
      }
    } catch (error) {
      this.isLoading=false
      console.error("Error fetching data:", error);
    }
  }


  formatNumber(value: any) {
    if (value == null) return '0.00';

    const num = typeof value === 'string' ? parseFloat(value) : value;

    if (typeof num !== 'number' || isNaN(num)) return value;

    // Round the number to two decimal places
    const roundedValue = Math.round(num * 100) / 100;

    const strNum = roundedValue.toString();

    // Check if it has trailing zeros after decimal or no decimal point
    if (!strNum.includes('.') || strNum.endsWith('.00')) {
      return roundedValue.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }

    return roundedValue.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  onPageChange(event:any){
    this.currentPage=event.page + 1
    this.limit=event.rows
    this.fetchData()
  }

  compareItemNo(a: string, b: string): number {
    const hasUnderscoreA = a.includes('_');
    const hasUnderscoreB = b.includes('_');

    if (hasUnderscoreA && hasUnderscoreB) {
      const [prefixA, numberA] = a.split('_');
      const [prefixB, numberB] = b.split('_');

      const prefixComparison = prefixA.localeCompare(prefixB);

      if (prefixComparison !== 0) {
        return prefixComparison;
      }

      const numberComparison = parseInt(numberA, 10) - parseInt(numberB, 10);
      return numberComparison;
    } else {
      const numericComparison = parseInt(a, 10) - parseInt(b, 10);
      return numericComparison;
    }
  }

  onClickGr(rowNode: any) {
    this.selectedIrData = []
    this.selectedPoData = []
    this.irNo = rowNode.node.data.ir_no
    let children_data = rowNode.node.children
    this.selectedIrData.push(rowNode.node.data)
    children_data.forEach((data: any) => {
      this.selectedPoData.push(data.data)
      this.poNo = data.data.vendor_code
    })
    this.sidebarVisible = true;
  }

  exportToExcel(selectedIrData: any[], selectedPoData: any[]) {
    import("xlsx").then(xlsx => {

      const irSetVal = selectedIrData.map(data => {
        return {
          'IR No': data['ir_no'],
          'Vendor Code': data['vendor_code'],
          'Vendor Name': data['vendor_name'],
          'IR Date': data['ir_date'],
          'Status': data['payment_status'],
          'IR Time': data['ir_time'],
          'Net Value': data['net_value'],
          'Tax Value': data['tax_value'],
          'Gross Value': data['gross_value'],
          'Invoice No': data['invoice_no'],
          'Invoice Date': data['invoice_date'],
          'Business Place': data['business_place']
        };
      })

      const poSetVal = selectedPoData.map(data => {
        return {
          'GR No': data['ir_no'],
          'PO No': data['vendor_code'],
          'Line Item No': data['vendor_name'],
          'Material Code': data['ir_date'],
          'Description': data['ir_time'],
          'UoM': data['net_value'],
          'Total': data['tax_value'],
          'Tax Value': data['gross_value'],
          'Gross Value': data['invoice_no'],
          'Net Value': data['invoice_date'],
          'IR Batch': data['business_place'],
          'IR Quantity': data['ir_quantity'],
        };
      })
      const worksheet1 = xlsx.utils.json_to_sheet(irSetVal);
      const worksheet2 = xlsx.utils.json_to_sheet(poSetVal);

      const workbook = {
        Sheets: {
          'selectedGrData': worksheet1,
          'selectedPoData': worksheet2
        },
        SheetNames: ['selectedGrData', 'selectedPoData']
      };

      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "ir");
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  transformKey(key: string): string {
    // Transform camelCase key to readable format
    return key.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/_/g, ' ').toUpperCase();
  }

  getSeverity(status: string): string {
    if (!status) {
      return 'info';
    }

    switch (status) {
      case 'Open Payment':
        return 'openPayment';
      case 'Partially Paid':
        return 'partiallypaid';
      case 'Paid':
        return 'paid';
      default:
        return 'info';
    }
  }


  getSeverityClass(severity: string): string {
    switch (severity) {
      case 'openPayment':
        return 'openPayment';
      case 'partiallypaid':
        return 'partiallypaid';
      case 'paid':
        return 'paid';
      default:
        return '';
    }
  }

  exportPdf(selectedIrData: any[], selectedPoData: any[]) {
    let startY = 75;
    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default('p', 'pt'); // 'p' for portrait orientation

        // Adding data from this.selectedASN
        autoTable(doc, {
          // head: [['Header', 'Value']], // Provide a single header row for the table
          body: selectedIrData.reduce((acc: any[], item: any) => {
            // For each item in selectedASN, create an array containing header and value pairs
            Object.entries(item).forEach(([key, value]) => {
              // Convert value to string if necessary
              let valueString = value !== null && value !== undefined ? value.toString() : '';
              let readableKey = this.transformKey(key);
              acc.push([readableKey, valueString]);
            });
            return acc;
          }, []),
          startY: startY,
          theme: 'striped',
          styles: { cellPadding: 4, fontSize: 10, halign: 'left' },
          headStyles: { halign: 'left' },
          didParseCell: function (data: any) {
            // Ensure data.cell.text is a string
            let text = typeof data.cell.text === 'string' ? data.cell.text : '';
            // Adjust column width dynamically based on content
            let colWidth = doc.getStringUnitWidth(text) * 10 * 1.1; // Assuming font size 10, adjust if needed
            if (doc.internal.pageSize.width < colWidth + 20) {
              doc.internal.pageSize = {
                width: colWidth + 20,
                getWidth: () => colWidth + 20,
                height: doc.internal.pageSize.height,
                getHeight: () => doc.internal.pageSize.height
              };
            }
          }
        });

        // Calculate the height of the first table to determine startY for the second table
        const rowCount1 = selectedIrData.length; // Assuming selectedASN is an array of objects
        const lineHeight = 12; // Adjust according to your font size and line height
        const tableHeight1 = rowCount1 * lineHeight * 200; // Estimating the table height based on row count and font size
        startY += tableHeight1 + 400; // Increased spacing between tables

        // Adding data from this.selectedASNScheduleDeliveries
        let header = "Schedule Deliveries"

        autoTable(doc, {
          head: [['GR No', 'PO No', 'Line Item No', 'Material Code', 'Description', 'UoM', 'Total','Tax Value','Gross Value','Net Value','IR Batch','IR Quantity'  ]],  // Provide headers from cols3
          body: selectedPoData.map(row => this.cols.map(col => row[col.field])), // Map data to match headers
          startY: startY,
          theme: 'striped',
          styles: { cellPadding: 3, fontSize: 10, halign: 'left' },
          headStyles: { halign: 'left' },
          didParseCell: function (data: any) {
            // Ensure data.cell.text is a string
            let text = typeof data.cell.text === 'string' ? data.cell.text : '';
            // Adjust column width dynamically based on content
            let colWidth = doc.getStringUnitWidth(text) * 10 * 1.1; // Assuming font size 10, adjust if needed
            if (doc.internal.pageSize.width < colWidth + 20) {
              doc.internal.pageSize = {
                width: colWidth + 20,
                getWidth: () => colWidth + 20,
                height: doc.internal.pageSize.height,
                getHeight: () => doc.internal.pageSize.height
              };
            }
          }
        });

        doc.save('ir.pdf');
      });
    });
  }


  onClickExcel(){
    this.isExcel=true
  }
  onCloseForExcelReport(){
    this.isExcel=false
    this.startDate=null
    this.endDate=null
    this.dateValidation=false
  }

  onDowunloadIrListByDate(){
    if (this.startDate != null && this.endDate != null) {

    let date:FilterDate = {
      startDate:this.datePipe.transform(this.startDate, 'yyyy-MM-dd'),
      endDate:this.datePipe.transform(this.endDate, 'yyyy-MM-dd HH:mm:ss')
    }
    this.isLoading=true
    this.isExcel=false
    this.grIrService.downloadIrByDate(date).then((res)=>{
      const fileContent = res.filecontent;
      const blob = new Blob([new Uint8Array(fileContent)], {
        type: 'application/octet-stream'
      });

      const downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = `ir_report${date.startDate}_${date.endDate}.xlsx`;

      document.body.appendChild(downloadLink);
      downloadLink.click();
      this.onCloseForExcelReport();
      this.isLoading=false
      this.messageService.add({ severity: "success", summary: 'Success', detail: "Ir Report downloaded successfully."})
    }).catch((error)=>{
      console.log(error)
    })

  }
  }


  downloadExcel() {

    // Format data for each section of the sheet
    const formattedData1 = this.formatDataForExcel(this.selectedIrData);
    const formattedData2 = this.formatDataForExcel2(this.selectedPoData);

    // Convert each formatted data to a worksheet format
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);

    // Append the first list (PO List)
    XLSX.utils.sheet_add_json(ws, formattedData1, { origin: 'A1' });

    // Auto-size columns for the first section
    this.calculateColumnWidths(ws, formattedData1);

    // Get the next available row after the first list
    const rowOffset1 = formattedData1.length + 3; // Adding 2 to leave space between sections

    // Append the second list (Item Details) below the first one
    XLSX.utils.sheet_add_json(ws, formattedData2, { origin: `A${rowOffset1}` });

    // Auto-size columns for the second section
    this.calculateColumnWidths(ws, formattedData2);

    // Create a new workbook and append the single sheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'IR Details');

    // Write the Excel file
    XLSX.writeFile(wb, 'ir_details.xlsx');
}

formatDataForExcel(data: any[]): any[] {
  if (!data || data.length === 0) {
    return []; // Return an empty array if data is empty or undefined
  }

    return data.map(data => ({
        'IR No': data['ir_no'],
        'Vendor Code': data['vendor_code'],
        'Vendor Name': data['vendor_name'],
        'IR Date': data['ir_date'],
        'Status': data['payment_status'],
        'IR Time': data['ir_time'],
        'Net Value': data['net_value'],
        'Tax Value': data['tax_value'],
        'Gross Value': data['gross_value'],
        'Invoice No': data['invoice_no'],
        'Invoice Date': data['invoice_date'],
        'Business Place': data['business_place']
      }
      ));
}

formatDataForExcel2(data: any[]): any[] {
  if (!data || data.length === 0) {
    return []; // Return an empty array if data is empty or undefined
  }

    return data.map(data => ({
      'GR No': data['ir_no'],
      'PO No': data['vendor_code'],
      'Line Item No': data['vendor_name'],
      'Material Code': data['ir_date'],
      'Description': data['ir_time'],
      'UoM': data['net_value'],
      'Total': data['tax_value'],
      'Tax Value': data['gross_value'],
      'Gross Value': data['invoice_no'],
      'Net Value': data['invoice_date'],
      'IR Batch': data['business_place'],
      'IR Quantity': data['ir_quantity'],
    }));
}
  calculateColumnWidths(ws: XLSX.WorkSheet, data: any[]) {
    if (!data || data.length === 0) {
      return; // Return an empty array if data is empty or undefined
    }else{
      const colWidths: number[] = [];
      const keys = Object.keys(data[0]);

      keys.forEach((key, colIndex) => {
          let maxWidth = key.length;
          data.forEach(row => {
              maxWidth = Math.max(maxWidth, row[key] ? row[key].toString().length : 0);
          });
          colWidths[colIndex] = maxWidth + 2;
      });

      ws['!cols'] = colWidths.map(width => ({ wch: width + 2 }));
    }
    }

    validateDate() {
      if (this.startDate && this.endDate) {
        const difference = this.getDateDifference();
        if (difference > 4 || this.endDate < this.startDate) {
          this.dateValidation = true;
        } else {
          this.dateValidation = false;
        }
      }
    }

    getDateDifference(): number {
      if (this.startDate && this.endDate) {
        const start = new Date(this.startDate);
        const end = new Date(this.endDate);
        const diffTime = Math.abs(end.getTime() - start.getTime());
        const diffMonths = diffTime / (1000 * 3600 * 24 * 31); // approx. 30 days in a month
        return diffMonths;
      }
      return 0;
    }


}
